export default __webpack_public_path__ + "static/1-aa901977890b76832784cd5bc54a49e5.jpg";